export const TRADING_STORAGE_VERSION = 2;
export class TradingStorage {
    adapter;
    storageKey;
    constructor(adapter, storageKey = "vnsc_paper_trading_v1") {
        this.adapter = adapter;
        this.storageKey = storageKey;
    }
    async saveState(state) {
        await this.adapter.setItem(this.storageKey, JSON.stringify({ ...state, version: TRADING_STORAGE_VERSION }));
    }
    async loadState() {
        try {
            const raw = await this.adapter.getItem(this.storageKey);
            if (raw == null)
                return null;
            const parsed = JSON.parse(raw);
            if (parsed == null)
                return null;
            const version = parsed.version;
            // S6 migration: version-1 ledgers load intact, config stays empty
            // (defaults apply) and the next save upgrades the envelope to v2.
            if (version === 1) {
                return { ...parsed, version: 2 };
            }
            if (version !== TRADING_STORAGE_VERSION)
                return null;
            return parsed;
        }
        catch {
            return null;
        }
    }
    async clearState() {
        await this.adapter.removeItem(this.storageKey);
    }
}
